import React from "react";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";
import BatchPrintPisAndForm2307Panel from "./components/BatchPrintPisAndForm2307Panel";

const BatchPrintPisAndForm2307Page = () => {
  const navigate = useNavigate();

  return (
    <div className="p-6 bg-gray-50 min-h-screen">
      <div className="mb-6 flex items-center justify-between gap-3 flex-wrap">
        <div>
          <h1 className="text-2xl font-bold text-gray-800">
            Batch Printing of PIS and Form2307
          </h1>
          <p className="text-sm text-gray-600">
            Enter CV range, retrieve generated files, then merge all PDFs into one print-ready file.
          </p>
        </div>
        <button
          onClick={() => navigate("/settlement-list")}
          className="inline-flex items-center gap-2 px-3 py-1.5 text-sm border rounded hover:bg-gray-100"
        >
          <FontAwesomeIcon icon={faArrowLeft} />
          Back to Settlement List
        </button>
      </div>

      <div className="bg-white rounded-xl shadow-xl border border-gray-100 p-4">
        <BatchPrintPisAndForm2307Panel />
      </div>
    </div>
  );
};

export default BatchPrintPisAndForm2307Page;
